import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ComponentsModule } from './components/components.module';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { PoliticasPrivacidadRentascrComponent } from './components/politicas-privacidad-rentascr/politicas-privacidad-rentascr.component';
import { DeleteDataRentascrComponent } from './components/delete-data-rentascr/delete-data-rentascr.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'politicas_privacidad_rentasCR', component: PoliticasPrivacidadRentascrComponent },
  { path: 'delete_data_rentasCR', component: DeleteDataRentascrComponent },
  { path: '**', redirectTo: '' }
];

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ComponentsModule,
    NgbModule,
    HttpClientModule,
    FormsModule,
    RouterModule.forRoot(routes)
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }

/*
 * Rutas disponibles en la aplicación:
 * - /                                -> Página principal (Home)
 * - /politicas_privacidad_rentasCR   -> Políticas de Privacidad y Uso de rentasCR
 * - /delete_data_rentasCR            -> Solicitud de Eliminación de Datos y Cuenta rentasCR
 */
